module.exports = __webpack_public_path__ + "img/212.cffcae34.jpg";